import {FC, useEffect} from 'react';
import {Box} from '@mui/material';
import AuctionHeader from '../components/AuctionHeader';
import AuctionItemsList from '../components/AuctionItemsList';
import {silentAuction} from './silentAuction.styles';
import {useAppDispatch, useAppSelector} from '@/store/hooks';
import {getAuctionCategories, getAuctionCategoriesSelector} from '@/store/organization-auction';
import {useAuctionTimer} from '@/utils/hooks';
import {getCurrentEventSelector} from '@/store/organization-event';
import {userAPI} from '@/core/api';

const SilentAuction: FC = () => {
	const dispatch = useAppDispatch();
	const categories = useAppSelector(getAuctionCategoriesSelector);

	const event = useAppSelector(getCurrentEventSelector);

	const {hasEnded} = useAuctionTimer(event?.endAuctionData);

	useEffect(() => {
		const getCategoryData = async () => {
			await dispatch(getAuctionCategories(userAPI)).unwrap();
		};

		getCategoryData();
	}, []);

	return (
		<Box sx={silentAuction.wrapper}>
			<AuctionHeader />
			<AuctionItemsList categories={categories ?? []} auctionType="Silent" hasEnded={hasEnded} key="Silent" />
		</Box>
	);
};

export default SilentAuction;
